import { Controller } from "@hotwired/stimulus"

// Announces a deck slide's CURRENT review status to the rest of the page,
// every time this element enters the DOM (card #2268 follow-up).
//
// decks/_slide_review_actions is server-rendered inline for every slide on
// initial page load, AND turbo_stream.replace'd wholesale by
// DeckSlideReviewsController#set_status/set_status.turbo_stream.erb whenever
// a decision (Approved/Under Review/Rejected) is made — Turbo swaps in a
// fresh element carrying this SAME data-controller attribute, so connect()
// fires again with the new status baked in from the server.
//
// airdrop_report_viewer_controller.js listens for the "slide-review:updated"
// document event this dispatches to keep its own cached data-review-status
// attribute (read once at initial render, driving the show page's
// review-status filter — card #2268) in sync live, WITHOUT a page reload.
// Before this, approving/rejecting a slide updated the status pill/banner in
// place (set_status.turbo_stream.erb's three replaces) but never touched the
// filter's copy of the status, so a just-approved slide stayed invisible
// under the Approved filter until a full reload.
export default class extends Controller {
  static values = {
    slideUuid: String,
    status: String
  }

  connect() {
    document.dispatchEvent(new CustomEvent("slide-review:updated", {
      detail: {
        slideUuid: this.slideUuidValue,
        status: this.statusValue
      }
    }))
  }
}
